import { render, staticRenderFns } from "./FileDownload.vue?vue&type=template&id=a605e1a2&scoped=true&lang=pug"
import script from "./FileDownload.vue?vue&type=script&lang=js"
export * from "./FileDownload.vue?vue&type=script&lang=js"
import style0 from "./FileDownload.styl?vue&type=style&index=0&id=a605e1a2&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a605e1a2",
  null
  
)

export default component.exports